(function (ws) {
    'use strict';
    ws.views.productGallery = Backbone.View.extend({

        events: {
            'click #thumbnails a': 'pdpGallery',
            'mouseover #big-image': 'pdpLargeImgShow',
            'mouseout #big-image': 'pdpLargeImgHide',
            'touchstart #big-image': 'pdpLargeImgShowTablet',
            'touchstart .pdp-close-button': 'pdpLargeImgHide'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$bigImage = this.$('#big-image img');
            this.$largeImageCont = this.$('#large-image');
            this.$largeImage = this.$largeImageCont.find('img');
        },

        /**
         * Photo Gallery
         */
        pdpGallery: function (e) {
            var $el = $(e.target);
            var bigSrc = $el.data('primaryimagesrc');
            this.$bigImage.attr('src', bigSrc);
            var largeSrc = $el.data('large-src');
            this.$largeImage.attr('src', largeSrc);
        },

        /**
         *  Large Image Show
         */
        pdpLargeImgShow: function () {
            this.$largeImageCont.show();
        },

        /**
         * Large Image Hidden
         */
        pdpLargeImgHide: function () {
            this.$largeImageCont.hide();
        },

        /**
         * Large Image Show in tablet
         */
        pdpLargeImgShowTablet: function () {
            this.$largeImageCont.show();
        }
    });
})(westcon);
